import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setting-child-page" }
const _hoisted_2 = { class: "setting-child-body" }
const _hoisted_3 = { class: "bottom-container" }
const _hoisted_4 = { class: "button-group" }

interface IProps {
    tipText?: string
    restoreText?: string
    saveText?: string
    restoreLoading?: boolean
    saveLoading?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    tipText: { default: '设置完成后，请保存设置' },
    restoreText: { default: '恢复默认' },
    saveText: { default: '保存设置' },
    restoreLoading: { type: Boolean, default: false },
    saveLoading: { type: Boolean, default: false }
  },
  emits: ["restore", "save"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit

function handleRestore() {
    emits('restore')
}

function handleSave() {
    emits('save')
}

return (_ctx: any,_cache: any) => {
  const _component_vkn_button = _resolveComponent("vkn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_ctx.tipText), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_vkn_button, {
          label: _ctx.restoreText,
          type: "info",
          size: "large",
          loading: _ctx.restoreLoading,
          onClick: handleRestore
        }, null, 8, ["label", "loading"]),
        _createVNode(_component_vkn_button, {
          class: "insert-btn",
          label: _ctx.saveText,
          type: "primary",
          "icon-placement": "left",
          size: "large",
          loading: _ctx.saveLoading,
          onClick: handleSave
        }, null, 8, ["label", "loading"])
      ])
    ])
  ]))
}
}

})